<template>
  <div class="kt-portlet kt-portlet--height-fluid">
    <div class="kt-portlet__body">
      <v-card>
        <v-tabs
          next-icon="fad fa-arrow-square-right"
          prev-icon="fad fa-arrow-square-left"
          show-arrows
        >
          <template v-for="(internetShop, index) in internetShops">
            <v-tab>{{ dealerName(internetShop, index) }}</v-tab>
            <v-tab-item>
              <div class="row">
                <div class="col-lg-8">
                  <shop-logs :internet-shop="internetShop"></shop-logs>
                </div>
                <div class="col-lg-4">
                  <side-widget
                    :shop="internetShop"
                    :is-true-car="isTrueCar"
                  ></side-widget>
                </div>
              </div>
              <template v-if="isTrueCar">
                <div class="row">
                  <div class="col-lg-12">
                    <true-car :internet-shop="internetShop"></true-car>
                  </div>
                </div>
              </template>
            </v-tab-item>
          </template>
        </v-tabs>
      </v-card>
    </div>
  </div>
</template>
<script>
import ShopLogs from '../ShopPost/ShopLogs.vue';
import SideWidget from '../ShopPost/SideWidget.vue';
import TrueCar from '@/components/client-shops/ShopPost/TrueCar';

export default {
  name: 'DealerLogs',

  components: {
    TrueCar,
    ShopLogs,
    SideWidget,
  },

  props: {
    internetShops: {
      required: true,
      type: Array,
    },
    hideDealerName: {
      default: false,
    },
    isTrueCar: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    dealerName(shop, index) {
      if (!shop.is_dealer) {
        return this.hideDealerName ? `Local Competitor` : shop.competitor.name;
      }
      return shop.specific_dealer.name;
    },
  },
};
</script>
